import React, {Component} from "react";
import axios from "axios";
// import Datetime from "react-datetime"
// import "react-datetime/css/react-datetime.css";

/* Import Components */
import CheckBox from "../components/CheckBox";
import Input from "../components/Input";
import TextArea from "../components/TextArea";
import Select from "../components/Select";
import Button from "../components/Button";

// const Cart = props =>
// console.log(this);

// console.log(this.order.products);

// const Order = ({products}) => products;


// console.log(this.props.products);

// const FormContainer = ({products}) =>  console.log(products);

// console.log(Order);

const refreshPage = () => {
    // window.location.reload();
    setTimeout(() => {
        window.location.reload()
    }, 1000);
};

var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();
// today = mm + '-' + dd + '-' + yyyy;
today = yyyy + '-' + mm + '-' + dd
// var today = "2021-01-15";


const consoleItems = () => {
    console.log(this.props.products)
}

// var arryOrder = [];
// var orderData = null;
// function phoneCheck(e) {
//     let prep_val
//     let element
//     if (e === undefined) {
//         prep_val = cart.customer.phone
//         element = document.getElementById("form_order_phone")
//     } else {
//         e.preventDefault()
//         element = e.target
//         if (e.type === "keydown") {
//             switch (e.key) {
//                 case "Backspace":
//                     prep_val = String(e.target.value.substr(0, e.target.value.length - 1)).replace("+7", '')
//                     break;
//                 case "Delete":
//                     prep_val = ""
//                     break;
//                 default:
//                     prep_val = e.target.value + e.key
//                     break;
//             }
//         } else if (e.type === "change") {
//             prep_val = e.target.value
//         }
//     }
//     const val = String(prep_val).replace("+7", '') //получаем грязный ввод
//     const digits = val.replace(/\D/g, '')
//     console.log(digits)
//     let result = ""
//     if (digits.length > 10) {
//         console.log("triggered")
//         //Введено больше символов, чем нужно. Отсекаем первые
//         const resultDigits = digits.substring(digits.length - 10, digits.length)
//         result = "+7 (" + resultDigits.substr(0, 3) + ") " + resultDigits.substr(3, 3) + "-" + resultDigits.substr(6, 2) + "-" + resultDigits.substr(8, 2)
//     } else {
//         if (digits.length >= 0) {
//             result += "+7 ("
//         }
//         if (digits.length > 0) {
//             result += digits.substr(0, 3)
//         }
//         if (digits.length > 3) {
//             result += ") " + digits.substr(3, 3)
//         }
//         if (digits.length > 6) {
//             result += "-" + digits.substr(6, 2)
//         }
//         if (digits.length > 8) {
//             result += "-" + digits.substr(8, 2)
//         }
//     }
//     if (digits.length >= 10) {
//         //Номер введён полностью
//         cart.customer.phone = result
//         localStorage.setItem("delivery.cart", JSON.stringify(cart))
//         document.getElementById("form_order_send_button").disabled = false
//     } else {
//         document.getElementById("form_order_send_button").disabled = true
//     }
//     element.value = result
// }


class FormContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // isLoggedIn: false,


            // view: "main",
            // startDate: "",
            customer: {

                name: "",
                email: "",
                phone: null,
                address: null,
                // due: "2020-12-12T12:00:00.000Z",

                // skills: [],
                // gender: "",
            },

            showConfirm: false,

            deliveryCost: 0,
            // due: null,
            // due: "2021-01-15",
            due: today,

            items: [],
            sum: 0,
            weight: 0,

            // genderOptions: ["Male", "Female", "Others"],
            // skillOptions: ["Programming", "Development", "Design", "Testing"]
        };
        this.handleTextArea = this.handleTextArea.bind(this);
        this.handlePhone = this.handlePhone.bind(this);
        this.handleFullName = this.handleFullName.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleClearForm = this.handleClearForm.bind(this);

        this.handleRefreshPage = this.handleRefreshPage.bind(this);
        // this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleInput = this.handleInput.bind(this);

        this.handleEmail = this.handleEmail.bind(this);
        this.handleDue = this.handleDue.bind(this);

        this.handleCheckDelivery = this.handleCheckDelivery.bind(this);
        // this.handleChange(this)= this.handleChange.bind(this);

        this.changeView = this.changeView.bind(this);


        // Test handlers
        // this.handleLoginClick = this.handleLoginClick.bind(this)
        // this.handleLogoutClick = this.handleLogoutClick.bind(this)
        // this.state = { isLoggedIn: false }
        console.log(this.props.products);

        // Обработака продуктов и занесение в state

        let prod = this.props.products;
        prod = prod.filter(item => item.quantity !== 0);
        // orderProds = [];
        prod.forEach(function (obj) {
            obj.Amount = obj.quantity;
            delete obj.quantity;
        });
        console.log(prod);
        // let a = prod.reduce((prev, next) => prev + (next.Price * next.Amount), 0);

        this.state.sum = prod.reduce((prev, next) => prev + (next.Price * next.Amount), 0);
        this.state.weight = prod.reduce((prev, next) => prev + ((next.Weight * next.Amount) / 1000), 0).toFixed(2);
        this.state.items = prod;

        console.log(this.state.sum, this.state.weight, this.state.items);
    }


    /* This lifecycle hook gets executed when the component mounts */
    changeView = where => this.setState({view: where});
    // handleChange = this.handleChange.bind(this);
    // handleChange(date) {
    //     this.setState({view: where})
    // }

    handleDue(date) {
        // let value = e.target.value;
        // this.setState(
        //     prevState => ({
        //
        //         // due: value
        //         customer: {
        //             ...prevState.customer,
        //             due: value.date.value
        //         }
        //     }),
        //     () => console.log(this.state.customer)
        // );
        // console.log(date)
        this.setState({
                // due: date.target.value
                due: date.target.value
            },
            () => console.log(this.state)
        );


        // this.setState({due: date.target.value}),
        //     () => console.log(this.state.due)
        // this.setState( {due: "2021-01-15T12:00:00.000Z"})

    }


    handleFullName(e) {
        let value = e.target.value;
        this.setState(
            prevState => ({
                customer: {
                    ...prevState.customer,
                    name: value
                }
            }),
            () => console.log(this.state.customer)
        );
    }

    handleEmail(e) {
        let value = e.target.value;
        this.setState(
            prevState => ({
                customer: {
                    ...prevState.customer,
                    email: value
                }
            }),
            () => console.log(this.state.customer)
        );
    }

    handlePhone(e) {
        let value = e.target.value;
        this.setState(
            prevState => ({
                customer: {
                    ...prevState.customer,
                    phone: value
                }
            }),
            () => console.log(this.state.customer)
        );
    }

    handleInput(e) {
        console.log("handleInput name");
        let value = e.target.value;
        let name = e.target.name;
        this.setState(
            prevState => ({
                customer: {
                    ...prevState.customer,
                    [name]: value
                }
            }),
            () => console.log(this.state.customer)
        );
    }

    handleTextArea(e) {
        console.log("Inside handleTextArea / address");
        let value = e.target.value;
        this.setState(
            prevState => ({
                customer: {
                    ...prevState.customer,
                    address: value
                }
            }),
            () => console.log(this.state.customer)
        );
    }

    // handleCheckDelivery(e) {
    //     let post = {
    //         "customer": {
    //             "name": "Константин",
    //             "email": "TEST@TEST.TEST",
    //             "phone": "+7 (888) 888-88-88",
    //             "address": "Большая филевская, 2"
    //         }, "due": "2020-11-17T07:30:00.000Z", "sum": 0, "weight": 0.5
    //     }
    //     console.log(post);
    //     var config = {
    //         method: 'post',
    //         url: 'https://prod-36.westeurope.logic.azure.com:443/workflows/c9ba73c4f31f4e58a4775eccb418f413/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=o-Vp-2Wkf4MGyCMfvfXMyUiN57RFruTuM7bLi4nninU',
    //         // url: 'localhost',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         data: post
    //     };
    //
    //     axios(config)
    //         .then(function (response) {
    //             console.log(JSON.stringify(response.data));
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }


    handleFormSubmit(e,) {

        // this.handleSplicesArray(this.props.products);

        // console.log("123213213", this.props.products);
        // console.log(typeof(this.props.products), "typeof", this.props.products);
        // var orderProd = this.props.products.slice();
        // var orderProd = this.props.products;
        // orderProd.splice(orderProd.map(el => el.quantity).indexOf(0), 1);

        // orderProd.find(el => {
        //     return el.quantity !== 0
        // });
        // filter(el => el.quantity != 0)

        // orderProd = orderProd.map(item => item.find(el => el.quantity == 0));
        // orderProd.splice(orderProd.map(el => el.quantity).indexOf(0), 1);
        // arryOrder.splice(arryOrder.map(el => el.quantity).indexOf(0), 1);
        e.preventDefault();


        // let orderProds = this.props.products;
        //
        // orderProds = orderProds.filter(item => item.quantity !== 0);
        // // orderProds = [];
        // orderProds.forEach(function (obj) {
        //     obj.Amount = obj.quantity;
        //     delete obj.quantity;
        // });
        //
        // let userData = this.state.customer;
        //
        // var sumAll = orderProds.reduce((prev, next) => prev + (next.Price * next.Amount), 0);
        // var weightAll = orderProds.reduce((prev, next) => prev + ((next.Weight * next.Amount) / 1000), 0).toFixed(2);
        //
        // var orderData =
        //     {
        //         "weight": weightAll,
        //         "sum": sumAll + this.state.deliveryCost,
        //         "customer": userData,
        //         "due": "2020-12-12T12:00:00.000Z",
        //         // "due": "Требуется уточнить дату доставки",
        //         "items": orderProds
        //     };
        // console.log("orderData", orderData);
        //
        //
        // let post_deliveryCost = [
        //     {
        //         "customer": {
        //             "name": "Тест",
        //             "email": "TEST@TEST.TEST",
        //             "phone": "+7 (888) 888-88-88",
        //             "address": "Большая филевская, 2"
        //             // "declinedSubscription":false
        //         },
        //         // "items":null,
        //         "due": "2020-12-12T07:30:00.000Z",
        //         // "due": "Требуется уточнить дату доставки",
        //         "sum": 0,
        //         // "delivery":345,
        //         // "weight":0.9179999999999999
        //         "weight": 0.5
        //     }
        // ];


        let orderData =
            {
                "weight": this.state.weight,
                "sum": this.state.sum + this.state.deliveryCost,
                "customer": this.state.customer,
                // "due": "2020-12-12T12:00:00.000Z",
                "due": this.state.due + 'T12:00:00.000Z',
                "items": this.state.items
            }


        if ((this.state.customer.phone !== null) && (this.state.customer.address !== null)) {
            // if ((userData.phone !== null) && (userData.address !== null)) {
            // console.log('userData.customer.address', userData.customer.address)

            var data = JSON.stringify(orderData);
            console.log(data);
            var config = {
                method: 'post',
                url: 'https://prod-61.westeurope.logic.azure.com/workflows/38a9964fea154e4d9468e9a129449e24/triggers/manual/paths/invoke/?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=tA5eVVoHrCg_71Vl_z7YT-_6gzLec4yIr_SkOjokJNs',
                // url: 'localhost',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(config)
                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                })
                .catch(function (error) {
                    console.log(error);
                });

            setTimeout(() => {
                alert("Заказ оформлен!");
                window.location.reload()
            }, 1000);

        } else if ((this.state.customer.phone == null)) {
            // } else if ((userData.phone == null)) {
            alert("Не введен номер телефона или адрес доставки.")
        }

    };

    handleClearForm(e) {
        e.preventDefault();
        this.setState({
            // view: "main",
            deliveryCost: 0,
            customer: {

                name: "",
                email: "",
                phone: "",
                address: "",
                // due: "2020-12-12T12:00:00.000Z",
            },
            // due: [],
            // sum: "",
            // weight: ""
            showConfirm: false,
        });
    }

    handleRefreshPage(e) {
        e.preventDefault();
        setTimeout(() => {
            window.location.reload()
        }, 1000);
    }


    handleCheckDelivery(e) {
        e.preventDefault();

        // console.log(this.state.due);

        // let orderProds = this.props.products.splice(0);
        // orderProds = orderProds.filter(item => item.quantity !== 0);
        // orderProds.forEach(function (obj) {
        //     obj.Amount = obj.quantity;
        //     delete obj.quantity;
        // });
        // let weightAll = orderProds.reduce((prev, next) => prev + ((next.Weight * next.Amount) / 1000), 0).toFixed(2);
        // let sumAll = orderProds.reduce((prev, next) => prev + (next.Price * next.Amount), 0);


        // let due_1 = this.state.due;

        // console.log(due_1.toISOString());

        let post = {
            "customer": {
                // "name": "Константин",
                // "name": this.state.name,

                // "email": "",

                // "phone": "+7 (888) 888-88-88",
                // "address": "Большая филевская, 2"
                "address": this.state.customer.address,
            },
            "due": this.state.due + 'T12:00:00.000Z',
            "sum": this.state.sum,
            "weight": this.state.weight
        }
        console.log(post);
        let config = {
            method: 'post',
            url: 'https://prod-36.westeurope.logic.azure.com:443/workflows/c9ba73c4f31f4e58a4775eccb418f413/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=o-Vp-2Wkf4MGyCMfvfXMyUiN57RFruTuM7bLi4nninU',
            // url: 'localhost',
            headers: {
                'Content-Type': 'application/json'
            },
            data: post
        };

        let price = 0;

        axios(config)
            // .then(function (response) {
            //     console.log(JSON.stringify(response.data));
            //     price = JSON.stringify(response.data);
            //     price = parseInt(JSON.parse(price).price);
            //     this.setState({
            //         deliveryCost: price,
            //         // isLoading: false,
            //     })
            //     console.log("axios response", price, typeof (price));
            //     // this.state.deliveryCost = price;
            //     // console.log("this.state.deliveryCost", this.state.deliveryCost);
            //     // this.state.deliveryCost = price;
            //     // this.state.deliveryCost = 123;
            //     // console.log('123', this.state.view, this.state.deliveryCost)
            //
            // })
            .then((res) => {

                console.log("axios response", res.data, typeof (res.data), parseInt(res.data.price), this.state.sum);
                this.setState({deliveryCost: parseInt(res.data.price)});
                this.setState({showConfirm: true});
            })
            .catch(function (error) {
                console.log(error);
            });

        // this.setState({showConfirm: true});
        // this.state.showConfirm = true;
        console.log("this.state.deliveryCost", this.state.deliveryCost, "this.state.showConfirm " + this.state.showConfirm);
        // this.state.deliveryCost = 123;
        // console.log('123', this.state.view, this.state.deliveryCost)
    };


    render() {

        const showConfirm = this.state.showConfirm;

        return (
            <div>

                <form className="container-fluid">

                    {/*onSubmit={this.handleFormSubmit}*/}

                    {/*<Datetime*/}
                    {/*    value={this.state.startDate}*/}
                    {/*    onChange={this.handleChange}*/}
                    {/*    timeFormat={true}*/}
                    {/*    closeOnSelect={true}*/}
                    {/*    inputProps={{ placeholder: "Start Date" }}*/}
                    {/*/>*/}

                    {/*<div id="date-picker-example" className="md-form md-outline input-with-post-icon datepicker"*/}
                    {/*     inline="true">*/}
                    {/*    <input placeholder="Select date" type="text" id="example" className="form-control"/>*/}
                    {/*        <label htmlFor="example">Try me...</label>*/}
                    {/*        <i className="fas fa-calendar input-prefix"></i>*/}
                    {/*</div>*/}
                    {/*<input*/}
                    {/*    // inputType={"text"}*/}
                    {/*    title={"Предпочитаемая дата доставки"}*/}
                    {/*    type="date"*/}
                    {/*    min="2020-03-20"*/}
                    {/*    className="form-control"*/}
                    {/*    id="form_order_date"*/}
                    {/*    // onChange="setDate(this)"*/}
                    {/*    // onBlur="dateCheck()"*/}
                    {/*/>*/}

                    <Input
                        inputType={"text"}
                        id={""}
                        title={"Как к вам обрашаться?"}
                        name={"name"}
                        value={this.state.customer.name}
                        placeholder={""}
                        handleChange={this.handleInput}
                    />{" "}
                    {/* Address of the user */}

                    <Input
                        inputType={"text"}
                        title={"Ваша почта"}
                        name={"name"}
                        value={this.state.customer.email}
                        placeholder={""}
                        handleChange={this.handleEmail}
                    />{" "}

                    <Input
                        // id={"form_order_phone"}
                        inputType={"tel"}
                        name={"phone"}
                        title={"Телефон"}
                        value={this.state.customer.phone}
                        // pattern={"[0-9]{1}[0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2}"}
                        placeholder={"8 (800) 000-00-00"}
                        handleChange={this.handlePhone}
                    />{" "}
                    {/* Phone */}


                    {/*<label htmlFor="start">Предпочитаемая дата доставки</label>*/}
                    {/*<input*/}

                    {/*    // inputType={"text"}*/}
                    {/*    type={"date"}*/}
                    {/*    // inputType={"text"}*/}
                    {/*    min={"2020-03-20"}*/}
                    {/*    className={"form-control"}*/}
                    {/*    title={"Предпочитаемая дата доставки"}*/}
                    {/*    id={"form_order_date"}*/}
                    {/*    // value={this.state.customer.phone}*/}
                    {/*    value={this.state.customer.due.value}*/}
                    {/*    handleChange={this.handleDue}*/}
                    {/*    // onChange="setDate(this)"*/}
                    {/*    // onBlur="dateCheck()"*/}
                    {/*/>{" "}*/}

                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    {/*<Datetime*/}
                    {/*    value={this.state.customer.due}*/}
                    {/*    onChange={this.handleChange}*/}
                    {/*    timeFormat={true}*/}
                    {/*    inputProps={{ placeholder: "Start Date" }}*/}
                    {/*/>*/}


                    {/*<Select*/}
                    {/*  title={"Gender"}*/}
                    {/*name={"gender"}*/}
                    {/*options={this.state.genderOptions}*/}
                    {/*value={this.state.customer.gender}*/}
                    {/*placeholder={"Select Gender"}*/}
                    {/*handleChange={this.handleInput}*/}
                    {/*/>{" "}*/}
                    {/* Phone Selection */}

                    {/*<CheckBox*/}
                    {/*  title={"Skills"}*/}
                    {/*  name={"skills"}*/}
                    {/*  options={this.state.skillOptions}*/}
                    {/*  selectedOptions={this.state.customer.skills}*/}
                    {/*  handleChange={this.handleCheckBox}*/}
                    {/*/>{" "}*/}
                    {/*/!* Skill *!/*/}


                    <div>
                        <label htmlFor="start">Дата доставки </label>
                        <div>
                            <input

                                // align="center"
                                type="date"
                                // id="start"
                                // name="trip-start"
                                value={this.state.due}
                                onChange={this.handleDue}
                            />
                        </div>
                    </div>

                    <TextArea
                        // title={"About you."}
                        title={"Адрес доставки"}
                        rows={2}
                        value={this.state.customer.address}
                        name={"currentPetInfo"}
                        handleChange={this.handleTextArea}
                        // placeholder={"Describe your past experience and skills"}
                    />

                    {/*<label htmlFor="start">Дата доставки:</label>*/}
                    {/*<input type="date"*/}
                    {/*    // id="start"*/}
                    {/*    // name="trip-start"*/}
                    {/*       value={this.state.due}*/}
                    {/*       onChange={this.handleDue}*/}
                    {/*/>*/}
                    {/*<br/>*/}
                    {/*<span> *Стоимость доставки обсуждается с менеджером  </span>*/}


                    {/*<div id="form1" className="row">*/}
                    {/*    <Button*/}
                    {/*        action={this.handleFormSubmit}*/}
                    {/*        type={"primary"}*/}
                    {/*        title={"Подтвердить заказ"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*    /!*Submit *!/*/}
                    {/*    <Button*/}
                    {/*        action={this.handleClearForm}*/}
                    {/*        type={"secondary"}*/}
                    {/*        title={"Очистить"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*    <Button*/}
                    {/*        action={this.handleRefreshPage}*/}
                    {/*        type={"secondary"}*/}
                    {/*        title={"Закрыть"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*    <Button*/}
                    {/*        action={this.handleCheckDelivery}*/}
                    {/*        type={"secondary"}*/}
                    {/*        title={"Рассчитать стоимость доставки"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*</div>*/}

                    {/*/!*тернарный оператор*!/*/}
                    {/*<div>*/}
                    {/*    Состояние <b> {showConfirm ? 'true' : 'false' }  </b> showConfirm*/}
                    {/*</div>*/}

                    <div>
                        {/*<h2>Сумма заказа {this.state.sum}</h2>*/}
                        <h5>Сумма заказа {this.state.sum} </h5>
                        <h5>Стоимость доставки {this.state.deliveryCost} </h5>
                        <h2>Итог {this.state.sum + this.state.deliveryCost} </h2>
                        {/*<span>Адресс доставки {this.state.customer.address} </span><br/>*/}
                        {console.log(this.state.showConfirm)}
                    </div>

                    <div className="row">

                        {showConfirm ?
                            <div>
                                {/*"true"*/}

                                <Button
                                    action={this.handleFormSubmit}
                                    type={"primary"}
                                    title={"Подтвердить заказ"}
                                    style={buttonStyle}
                                />{" "}

                                {/*Submit */}
                                <Button
                                    action={this.handleClearForm}
                                    type={"secondary"}
                                    title={"Очистить"}
                                    style={buttonStyle}
                                />{" "}
                                <Button
                                    action={this.handleRefreshPage}
                                    type={"secondary"}
                                    title={"Закрыть"}
                                    style={buttonStyle}
                                />{" "}
                            </div>
                            :
                            <div className="row">
                                <Button
                                    action={this.handleCheckDelivery}
                                    type={"primary"}
                                    title={"Рассчитать стоимость доставки"}
                                    style={buttonStyle}
                                />{" "}
                            </div>

                        }

                    </div>


                    {/*<span> {this.state.customer.address} </span>*/}
                    {/*<div>*/}
                    {/*    /!*<h2>Сумма заказа {this.state.sum}</h2>*!/*/}
                    {/*    <h4>Сумма заказа {this.state.sum} </h4>*/}
                    {/*    <h4>Стоимость доставки {this.state.deliveryCost} </h4>*/}
                    {/*    <h2>Итог {this.state.sum + this.state.deliveryCost} </h2>*/}
                    {/*    /!*<span>Адресс доставки {this.state.customer.address} </span><br/>*!/*/}
                    {/*    {console.log(this.state.showConfirm)}*/}
                    {/*</div>*/}
                    {/* About you */}
                    {/*<div className="row">*/}
                    {/*    <Button*/}
                    {/*        action={this.handleFormSubmit}*/}
                    {/*        type={"primary"}*/}
                    {/*        title={"Подтвердить заказ"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*    /!*Submit *!/*/}
                    {/*    <Button*/}
                    {/*        action={this.handleClearForm}*/}
                    {/*        type={"secondary"}*/}
                    {/*        title={"Очистить"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*    <Button*/}
                    {/*        action={this.handleRefreshPage}*/}
                    {/*        type={"secondary"}*/}
                    {/*        title={"Закрыть"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*    <Button*/}
                    {/*        action={this.handleCheckDelivery}*/}
                    {/*        type={"secondary"}*/}
                    {/*        title={"Items"}*/}
                    {/*        style={buttonStyle}*/}
                    {/*    />{" "}*/}
                    {/*</div>*/}
                    {/* Clear the form */}
                </form>
                <footer>
                    <br/>
                    {/*<h4 align="center">  *Стоимость доставки обсуждается с менеджером </h4>*/}
                    <h5 align="center">Часы работы с 9:00 до 21:00. Дата и стоимость доставки
                        рассчитываются
                        индивидуально.</h5>
                    <div id="footer-farinari">
                        {/*<span>Farinari</span>*/}

                        {/*<a id="footer-phone" href="tel:+74959702442">+7 (495) 970-24-42</a>*/}
                    </div>
                    <br/>
                    <span>Сайт предоставлен в ознакомительных целях и не является публичной офертой. Все права защищены.</span><span>Farinari 2021</span>
                </footer>
            </div>
        );
    }
}

const
    buttonStyle =
        {
            margin: "10px 10px 10px 10px"
        }
;

export default FormContainer;
